import React from 'react';
import AsyncSection from '../../../../../../../../../../Components/AsyncSection';
import './index.scss';
// The card table, its two column palettes, and the stylesheet they need — this
// is the same table the single-round Key Takeaways section draws, only tagged
// by movement instead of severity.
import '../../../KeyTakeAways/index.scss';
import CategoryTable from '../../../KeyTakeAways/children/CategoryTable';
import { DEVELOPMENT_CONTENTS, STRENGTH_CONTENTS } from '../../../KeyTakeAways/constants';
import {
    DROPPED_LABEL,
    HEADER_TEXT,
    MOVEMENT,
    MOVEMENT_LABEL,
} from './constants';
import SVGIcons from '../../../../../../../../../../Components/SVGIcons';




// Sits where CategoryTable would otherwise put the severity pill.
const renderMovementTag = (item) => {
    if (!item.movement) return null;
    const isNew = item.movement === MOVEMENT.NEW;
    return (
        <span className={`ktcard__badge sgm__tag sgm__tag--${item.movement}`}>
            {isNew ? <SVGIcons type={"SVG-trendArrow"} /> : <SVGIcons type={"SVG-flatline"} />}
            {MOVEMENT_LABEL[item.movement]}
        </span>
    );
};

// The categories that were on this list at the earlier 360 and no longer are.
// They have no row of their own — dropping off the list is exactly the absence
// of one — so they're named underneath instead.
const DroppedList = (props) => {
    if (!props.categories || !props.categories.length) return <div />;
    return (
        <div className='sgm__dropped'>
            {props.categories.map((category) => (
                <div className='sgm__dropped-item' >
                    <span className='sgm__dropped-icon'><SVGIcons type={"SVG-trenddownArrow"} /></span>

                    <span className='sgm__dropped-name'>{category.category}</span>{' '}
                    <span className='sgm__dropped-label'>{DROPPED_LABEL}</span>
                </div>
            ))}
        </div>
    );
};

const StrengthsGrowthMovement = (props) => {
    const api = props.fetchTrendTopStrengthAndTopDevApi;
    const data = api.data || {};
    const strengths = {
        rows: data.strengthsData || [],
        dropped: data.strengthsLeftListData || [],
    };
    const growth = {
        rows: data.developmentAreasData || [],
        dropped: data.developmentAreasLeftListData || [],
    };

    return (
        <AsyncSection api={api} isEmpty={() => !strengths.rows.length && !growth.rows.length} loaderHeight={300} loaderWidth={600}>
        <div className='cardwrapper'>
            <h3>{HEADER_TEXT.title}</h3>
            <p className='description-container'>{HEADER_TEXT.description}</p>

            <div className='sgm'>
                <div className='keytakeaway-container'>
                    {strengths.rows.length > 0 && (
                        <CategoryTable
                            data={strengths.rows}
                            contents={STRENGTH_CONTENTS}
                            renderBadge={renderMovementTag}
                        />
                    )}
                    {growth.rows.length > 0 && (
                        <CategoryTable
                            data={growth.rows}
                            contents={DEVELOPMENT_CONTENTS}
                            renderBadge={renderMovementTag}
                        />
                    )}
                </div>

                {/* Kept out of the tables' subgrid and given their own row, so
                    the two boxes line up with each other however tall the cards
                    above them happen to be. */}
                    {(strengths.dropped.length > 0 || growth.dropped.length > 0) && (
                    <div className='sgm__dropped-row'>
                            {strengths.dropped.length > 0 && <DroppedList categories={strengths.dropped} />}
                            {growth.dropped.length > 0 && <DroppedList categories={growth.dropped} />}
                    </div>
                )}

                {HEADER_TEXT.notes.map((note) => (
                    <p className='sgm__note' key={note}>{note}</p>
                ))}
            </div>
        </div>
        </AsyncSection>
    );
};

export default StrengthsGrowthMovement;
